import { PassPageProps } from 'src/pages/PassPage/index'
import Modal from 'src/components/common/Modal'
import RenderIf from 'src/components/common/RenderIf'
import React from 'react'
import { useModal } from 'src/provider/ModalContextProvider'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16 } from 'src/styles/fonts/NotoSansKrFonts'
import Button, { ButtonOption1 } from 'src/components/common/Button'
import styled from 'styled-components'
import { layoutMaxSize } from 'src/styles/mixin'

const PassPageView = (props: PassPageProps) => {
  const { requestPCCFormRef, requestPCCForm, showIosPage } = props
  const { CryptoTokenID, IntegrityValue, ReqInfo, Version } = requestPCCForm
  const { isOpen: modalOpen } = useModal()

  return (
    <>
      <form
        ref={requestPCCFormRef}
        name="reqPCCForm"
        method="post"
        action="https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v3.jsp"
        hidden={true}
      >
        <input type="hidden" name="crypto_token_id" value={CryptoTokenID} />
        <input type="hidden" name="integrity_value" value={IntegrityValue} />
        <input type="hidden" name="reqInfo" value={ReqInfo} />
        <input type="hidden" name="verSion" value={Version} />
      </form>
      <RenderIf when={modalOpen}>
        <Modal />
      </RenderIf>
      <RenderIf when={showIosPage}>
        <S.PassContainer $option="flex_column">
          <S.PassContents $option="flex_column">
            <Container $option="flex_column" $row_gap="20px">
              <Typography $fontStyle={Noto_body1_r16}>
                사용 중인 서비스로 돌아가 계속 진행해주세요.
              </Typography>
            </Container>
            <S.PassButtonWrap>
              <Button
                option={ButtonOption1('default')}
                onClickFn={() => (window.location.href = 'couponwalletapp://payment_return')}
              >
                앱으로 돌아가기
              </Button>
            </S.PassButtonWrap>
          </S.PassContents>
        </S.PassContainer>
      </RenderIf>
    </>
  )
}
export default PassPageView

const S = {
  PassContainer: styled(Container)`
    ${layoutMaxSize};
    background-color: var(--white);
    margin: 0 auto;
    overflow: auto;
    min-height: calc(var(--vh, 1vh) * 100);
    height: 100%;
    align-items: center;
  `,
  PassContents: styled(Container)`
    max-width: 320px;
    flex: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    gap: 70px;
    padding: 0 20px;
    word-break: keep-all;
  `,
  PassButtonWrap: styled(Container)`
    padding: 0 10px;
  `,
}
